var map = {
	"./br/PT/S1/bg117.png": 45641,
	"./br/PT/bg117.png": 55658,
	"./in/EN/S1/bg117.png": 11220,
	"./in/EN/bg117.png": 66926,
	"./ph/EN/S1/bg117.png": 34945,
	"./ph/EN/bg117.png": 22482,
	"./vn/VI/S1/bg117.png": 7594,
	"./vn/VI/bg117.png": 13522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97989;